/**
 * Runtime environment variable accessor.
 *
 * In ECS (or any container), env vars from the task definition are injected at
 * container startup into `window.__env__` via the env-config.js script generated
 * by env.sh.  This function reads from that runtime object first, then falls
 * back to CRA's build-time `process.env` (used during local `npm start`).
 *
 * Usage:
 *   import { getEnv } from '../config/getEnv';
 *   const baseUrl = getEnv('REACT_APP_SF_BASE_URL') || '';
 */
export function getEnv(key) {
  // Runtime values injected by env.sh → env-config.js (ECS task definition)
  if (
    typeof window !== "undefined" &&
    window.__env__ &&
    window.__env__[key] !== undefined &&
    window.__env__[key] !== ""
  ) {
    return window.__env__[key];
  }
  // Build-time fallback (CRA local development via .env / .env.local)
  return process.env[key];
}
